import React, { useState } from 'react'
import { useRouter } from 'next/navigation'
import { ChevronDown } from 'lucide-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@rewardops/ui'

import { NavigationLink } from '~/context/resources-provider'

export type MenuLinkProps = {
  menu: {
    id: string
    name: string
    links: NavigationLink[]
  }
}

const DesktopMenuLink: React.FC<MenuLinkProps> = ({ menu }: MenuLinkProps) => {
  const [open, setOpen] = useState(false)
  const { push } = useRouter()

  const options = menu?.links?.map((menuLink) => {
    return {
      key: menuLink?.to,
      value: menuLink?.name,
      ...menuLink,
    }
  })

  const onOptionSelect = (option: NavigationLink) => {
    if (option?.isRelativeUrl == false) {
      window.open(option?.to, '_blank')
      return
    }

    push(option?.to)
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger className="flex cursor-pointer gap-1 text-sm capitalize hover:border-b-2 hover:border-tenant-primary-color hover:text-tenant-primary-color focus:outline-none">
        {menu.name} <ChevronDown />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {options?.map((option) => (
          <DropdownMenuItem
            key={option.key}
            className="group cursor-pointer hover:bg-tenant-primary-color"
            onSelect={() => {
              onOptionSelect(option)
              setOpen(false)
            }}
          >
            <span className="group-hover:text-white">{option.value}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { DesktopMenuLink }
